import { defaultColumns, defaultSort } from '../../components/data/shops/chains/columns';

export default {
  state: {
    shopChains: [],
    loading: false,
    tableConfig: null,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    shopChains: state => state.shopChains,
    loading: state => state.loading,
    tableConfig: state => state.tableConfig,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setShopChains(state, shopChains) {
      state.shopChains = shopChains;
    },
    setLoading(state, display) {
      state.loading = display;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
  },
  actions: {

    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/shop-chain-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'shop-chain-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'shop-chain-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAllWithPagination({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const shopChains = await axios.get('api/shop-chains-paginated' + (query || ''));
        commit('setShopChains', shopChains);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },

    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const shopChains = await axios.get('api/shop-chains');
        commit('setShopChains', shopChains);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/shop-chains/' + id);
      } catch (e) {
      }
    },

    async create({ commit }, payLoad) {
      try {
        await axios.post('api/shop-chains', payLoad);
      } catch (e) {
      }
    },

    async update({ commit }, payLoad) {
      try {
        await axios.put('api/shop-chains', payLoad);
      } catch (e) {
      }
    },

    async delete({}, id) {
      await axios.delete('api/shop-chains/' + id);
    }
  },
};
